import styled from "styled-components";
import PropTypes from "prop-types";
import { InputTextarea } from "primereact/inputtextarea";
import { Colors } from "../../constants/Colors";
import { Wrapper } from "../../constants/common/StyledGlobalConstants";
import { DropdownSelect } from "@vds/selects";

export function CustomisedLabel(props) {
  const Label = styled.label`
    font-weight: 700;
    font-size: 12px;
    line-height: 12px;
    margin-bottom: 12px;
  `;
  const RequiredStar = styled.span`
    color: ${Colors.activeDefault};
    font-size: 20px;
    padding: 0 0 0 3px;
    font-weight: 400;
  `;
  return (
    <Label>
      {props.children}
      {props.required ? <RequiredStar>*</RequiredStar> : ""}
    </Label>
  );
}

CustomisedLabel.propTypes = {
  children: PropTypes.node,
  required: PropTypes.bool
};

export const CountWrapper = styled.div`
  color: ${Colors.foregroundSecondaryText};
  margin-left: auto;
  margin-right: 0;
`;

export const ErrorBox = styled.div`
  display: flex;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  margin-top: 5px;
  flex-direction: ${(props) => (props.flexDirection ? props.flexDirection : "row")};
`;
export const ErrorWrapper = styled.div`
  color: ${Colors.error};
`;

export const CustomisedTextarea = styled(InputTextarea)`
  width: 100%;
  font-family: "neue-haas-grotesk-text" !important;
  color: ${Colors.black};
  font-size: 14px;
  height: ${(props) => (props.height ? props.height : `12rem !important`)};
  border: 1px solid ${(props) => (props.required ? `${Colors.error} !important` : `${Colors.grayBorder} !important`)};
  &:hover {
    border: 1px solid ${(props) => (props.required ? `${Colors.error} !important` : `${Colors.activeDefault} !important`)};
  }
  &:enabled {
    &:focus {
      border: 2px solid ${(props) => (props.required ? `${Colors.error} !important` : `${Colors.activeDefault} !important`)};
      box-shadow: unset;
    }
  }
`;

export const CPDropdown = styled(DropdownSelect)`
  margin-left: 0;
  width: 100%;
  min-width: inherit;
  border: ${(props) => props.errorBorder && `solid 1px ${Colors.error}`};
  border-radius: 4px;
  & div {
    width: 100%;
    & label {
      ::after {
        position: relative;
        content: "*";
        color: ${(props) => (props.disabled ? Colors.disabledText : Colors.activeDefault)};
        padding: 0 0 0 4px;
        top: -4px;
        font-size: 20px;
      }
      & p {
        font-family: "neue-haas-grotesk-text";
        font-weight: 700;
        font-size: 12px;
        line-height: 12px;
        margin-bottom: 8px;
        color: ${(props) => (props.disabled ? `${Colors.black}` : "")};
        display: ${(props) => (props.required ? "inline" : "")};
        & span {
          width: 80%;
          &::after {
            color: ${Colors.nickel};
            content: ${(props) => (props.translationContent ? `${props.translationContent}` : "")};
          }
        }
      }
    }
  }
  & span {
    & span {
      & div {
        height: 2.75rem;
        background: ${Colors.white};
        border: 1px solid ${Colors.grayBorder};
        border-radius: 4px;
        width: 100%;
        background: ${(props) => (props.disabled ? `${Colors.foregroundSecondarybackground}` : "")};
        &:hover {
          border: ${(props) => (props.disabled ? "" : `1px solid ${Colors.black} !important`)};
          border-radius: ${(props) => (props.disabled ? "" : "4px")};
        }
        & span {
          top: 0.8rem;
          & svg {
            min-width: 0.75rem;
            max-width: 0.75rem;
          }
        }
      }
    }
  }
  & select {
    font-family: "neue-haas-grotesk-text";
    font-weight: 400;
    font-size: 14px;
    padding: 12px 25px 12px 16px;
    color: ${Colors.black};
    margin: 0;
    &:disabled {
      color: ${Colors.black};
      -webkit-text-fill-color: ${Colors.black};
      background-color: transparent;
    }
  }
`;

export const CustomWrapper = styled(Wrapper)`
  &:focus {
    outline: none;
  }
`;
